<template>
  <section>
    <v-layout row wrap class="mt-5">
      <v-flex xs10 offset-xs1>
        <h3 class="display-3 accent--text">Notas parciales</h3>
        <v-layout row wrap>

          <v-flex xs4 class="px-2 py-2" v-for="item in cursos" :key="item.id">
            
            <div class="grab" @click="setCurrentCourse(item)" >
              <v-card flat color="light-blue lighten-1" class="white--text py-4 bordes" >
                <v-container fluid grid-list-lg>
                  <v-layout row>
                    <v-flex xs3>
                       <v-layout column align-center justify-center>
                          <v-layout justify-space-around class="circulo">
                            <v-icon x-large  color="light-blue lighten-1">library_books</v-icon>
                          </v-layout>
                        </v-layout>
                    </v-flex>
                    <v-flex xs7>
                      <div>
                        <div class="headline white--text">{{item.cource_title}}</div>
                      </div>
                    </v-flex>
                    <v-flex xs2>
                      <!-- <p class="white--text display-2 text-xs-center mb-0">1</p> -->
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card>
            </div>
          </v-flex>
        </v-layout>

  
        
      </v-flex>
    </v-layout>

    <v-layout row wrap class="mt-5">
      <v-flex xs10 offset-xs1>
        <v-layout row wrap>
          
        </v-layout>
      </v-flex>
    </v-layout>

<v-dialog 
  v-model="dialogNotas"
  transition="dialog-bottom-transition"
  max-width="80%"
  >
  <v-toolbar flat dark color="orange darken-4">
        <v-flex xs11 offset-xs1 >
          <v-card-title class="white--text pt-0 pb-0 headline">Datos de la Asigantura </v-card-title>
        </v-flex>
        <v-spacer></v-spacer>
        <v-btn flat icon color="white" @click.native="dialogNotas = false">
          <v-icon >close</v-icon>
        </v-btn>
      </v-toolbar>
  <v-card class="pa-4"  >
    
    <v-flex xs10 offset-xs1>
          <!--<h4 class="primary--text">Datos de la Asigantura</h4>-->
          <h5 >Curso: <strong class="secondary--text">{{courseAux.cource_title}}</strong></h5>
          <h5 >Nivel: <strong class="secondary--text">{{courseAux.level.level_name}}</strong></h5>
          <h5 >Codígo: <strong class="secondary--text">{{courseAux.cource_code}}</strong></h5>
          <v-divider></v-divider>
          <h4 class="primary--text text-md-center">Evaluaciones</h4>
          <v-card
          color="accent"
          v-for="item in qualification.member_qualification" :key="item.id">
            <v-layout row class="pa-3 mb-3">
              <v-flex xs10>
                <h6 class="title font-weight-thin" style="color:#F5F5F5;">Evaluación: <strong class="white--text"> {{item.qualification.qualification_descripcion}}</strong></h6>
                <h6 class="title font-weight-thin" style="color:#F5F5F5;">Fecha: <strong class="white--text"> {{item.qualification.qualification_surrender_date}}</strong></h6>
                <h6 class="title font-weight-thin" style="color:#F5F5F5;">Ponderación: <strong class="white--text"> {{item.qualification.qualification_weighing}}%</strong></h6>  
              </v-flex>
              <v-flex xs2>
                <v-layout column>
                  <h6 class="title font-weight-thin white--text">Nota</h6>
                  <h3 class="white--text">{{item.qualificationEstudent}}</h3>
                </v-layout></v-flex>
            </v-layout>
           
          </v-card>
          
          <v-flex xs2 offset-xs5 >
            <v-card color="primary">
              <v-layout column class="pa-2">
                  <h6 class="title font-weight-thin white--text text-md-center">Promedio</h6>
                  <h3 class="white--text text-md-center">{{qualification.promedio}}</h3>
                </v-layout>
          </v-card>
          <div class="mt-3" align="center">
            <v-btn color="success" @click.native="dialogNotas = false">Cerrar</v-btn>
          </div>
          
          </v-flex>


        </v-flex>
        </v-card>
  </v-dialog>
  </section>
  
</template>


<script>
import { getOneMemberQualificationService } from '@/services/Miembro/GetOneMemberQualification.service'
// import { getAllCurseOfUserService } from '@/services/GetAllCurseOfUser.service'
import { getEnrollUserInCurseService } from '@/services/GetEnrollUserInCurse.service'

export default {
  data () {
    return {
      dialogNotas: false,
      courseAux: {
        cource_title: '',
        level: {
          level_name: ''
        },
        cource_code: ''
      },
      qualification: [],
      idCurso: 0,
      cursos: []
    }
  },
  mounted () {
    let vm = this
    vm.idCurso = vm.$route.params.id
    vm.getUsersInCourseService()
  },
  methods: {
    setCurrentCourse (item) {
      let vm = this
      vm.dialogNotas = true
      vm.courseAux = item
      vm.loadQualification()
    },
    loadQualification () {
      let vm = this
      getOneMemberQualificationService.getById(vm.courseAux.course_id).then(data => {
        vm.qualification = data.body
      })
    },
    getUsersInCourseService () {
      let vm = this
      getEnrollUserInCurseService.query().then(data => {
        vm.cursos = data.body
      })
    }
  }
}
</script>

<style scoped>
.circulo {
     width: 60px;
     height: 60px;
     -moz-border-radius: 50%;
     -webkit-border-radius: 50%;
     border-radius: 50%;
     background: white;
}

.bordes {
  border-radius: 20px 20px 20px 20px;
-moz-border-radius: 20px 20px 20px 20px;
-webkit-border-radius: 20px 20px 20px 20px;
border: 0px solid #000000;
}
.enlace {
  text-decoration:none;
}
.grab {cursor: -webkit-grab; cursor: pointer;}
</style>


// WEBPACK FOOTER //
// src/components/Usuario/QualificationsForUser.vue